import { ConcreteException } from '../base.js';
import { mapErrorMessage } from '../utils/maps.js';
import { ErrorType } from '../types/index.js';
const removeOkxWalletFromErrorString = (message) => message
    .replaceAll('OkxWallet', '')
    .replaceAll('OkxWallet:', '')
    .replaceAll('Okx', '');
export class OkxWalletException extends ConcreteException {
    static errorClass = 'OkxWalletException';
    constructor(error, context) {
        super(error, context);
        this.type = ErrorType.WalletError;
    }
    parse() {
        const { message } = this;
        if (message
            .trim()
            .toLowerCase()
            .includes('missing or invalid parameters'.toLowerCase())) {
            this.setMessage('Please make sure you are using Okx Wallet');
        }
        else {
            this.setMessage(mapErrorMessage(removeOkxWalletFromErrorString(message)));
        }
        this.setName(OkxWalletException.errorClass);
    }
}
